/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseIcon16Regular = forwardRef('MediaUiAPauseIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.75 3a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0V3Z" }),
        React.createElement("path", { d: "M10.75 3a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0V3Z" })));
});
